var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-tags-view',{attrs:{"pre-selected-tags":_vm.userTags,"tags":_vm.tags,"loading":_vm.loading},on:{"save":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }